import { PortalBooking } from 'types/PortalBooking';

/* eslint-disable @typescript-eslint/no-explicit-any */
const convertPet = (dto: any) => ({ id: dto.id, name: dto.name, petType: dto.pet_type });

export const convertToPortalBooking = (dto: any): PortalBooking => ({
    id: dto.id,
    marketplaceId: dto.marketplace_id,
    canAddAddons: Boolean(dto.can_add_addons),
    totalPrice: dto.total_price,
    appointments: (dto.appointments ?? []).map((appointment: any) => ({
        id: appointment.id,
        date: appointment.date,
        service: {
            id: appointment.service.id,
            name: appointment.service.name,
            businessArea: appointment.service.business_area
        },
        pet: convertPet(appointment.pet),
        addonDates: appointment.addon_dates ?? []
    })),
    addons: (dto.addons ?? []).map((addon: any) => ({
        id: addon.id,
        addonServiceId: addon.addon_service_id,
        name: addon.name,
        pet: convertPet(addon.pet),
        date: addon.date,
        quantity: addon.quantity,
        price: addon.price,
        totalPrice: addon.total_price
    }))
});
